export default "__VITE_ASSET__DS67XWOV__"